// extracted by mini-css-extract-plugin
export var content = "index-module--content--s3pMT";
export var left = "index-module--left--DFHKw";
export var right = "index-module--right--S0Bbq";
export var title = "index-module--title--DOc0i";
export var wrapper = "index-module--wrapper--N98oq";